import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TranslationLanguageSetting } from '../../../models/translations/translation-language-setting.model';

@Injectable()
export class TranslationSettingsService {
  private readonly url: string = environment.api.API_ENDPOINT;

  public constructor(private httpClient: HttpClient) {}

  public get(): Observable<TranslationLanguageSetting> {
    return this.httpClient.get<TranslationLanguageSetting>(`${this.url}/translationsettings`);
  }

  public save(setting: TranslationLanguageSetting): Observable<TranslationLanguageSetting> {
    return this.httpClient.put<TranslationLanguageSetting>(`${this.url}/translationsettings`, setting);
  }
}
